export const profileSelectionScreenStyles = `
  .rak-root {
    position: relative;
    flex: 1 1 0%;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: var(--space-8) var(--space-6);
    overflow: hidden;
    background-color: var(--catchup-blue-50);
    background-size: 460px;
    background-image: linear-gradient(160deg, #DCF5FA 0%, #E7E9FB 50%, #FCE6EE 100%),
      url("/backgrounds/background-pattern-login.webp");
  }

  .rak-blobs {
    position: absolute;
    inset: 0;
    z-index: 0;
    overflow: hidden;
    pointer-events: none;
  }
  /* Static soft-gradient blobs. They used to float (rakBlobA/B/C: translate +
     scale, infinite), but continuously animating a blur(58px) + mix-blend layer
     that sits BEHIND the glass cards forced every card's backdrop-filter to
     re-blur on every frame — a constant full-screen repaint ("kasıyor"), even at
     rest. Held still, the whole background rasterizes once and the cards'
     backdrop stays cached. (The old prefers-reduced-motion guard that killed the
     animation is now unnecessary — there's no animation to kill.) */
  .rak-blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(58px);
    opacity: 0.6;
    mix-blend-mode: multiply;
  }
  .rak-blob--teal {
    width: 380px;
    height: 380px;
    background: radial-gradient(circle, #5FD2E6, transparent 70%);
    top: -80px;
    left: -40px;
  }
  .rak-blob--purple {
    width: 420px;
    height: 420px;
    background: radial-gradient(circle, #A78BFA, transparent 70%);
    top: 0;
    right: -120px;
  }
  .rak-blob--coral {
    width: 360px;
    height: 360px;
    background: radial-gradient(circle, #F98C6E, transparent 70%);
    bottom: -120px;
    left: 18%;
  }
  .rak-blob--gold {
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, #F8C24E, transparent 70%);
    bottom: 0;
    right: 10%;
  }

  .rak-inner {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 820px;
  }
  .rak-logo {
    height: 38px;
    object-fit: contain;
    margin-bottom: var(--space-4);
  }
  .rak-hello {
    display: inline-flex;
    align-items: center;
    gap: var(--space-2);
    margin-bottom: var(--space-5);
    padding: 7px 16px;
    border-radius: var(--rad-catchup-full);
    background: rgba(255, 255, 255, 0.32);
    border: 1px solid rgba(255, 255, 255, 0.6);
    -webkit-backdrop-filter: blur(14px);
    backdrop-filter: blur(14px);
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.7);
  }
  .rak-hello-text {
    font-size: var(--fs-base);
    color: var(--text-secondary);
    font-weight: 500;
  }
  .rak-hello-text b {
    color: var(--text-primary);
    font-weight: 700;
  }
  .rak-title {
    font-size: var(--fs-great);
    font-weight: 700;
    color: var(--text-primary);
    text-align: center;
  }
  .rak-sub {
    font-size: var(--fs-lg);
    color: var(--text-secondary);
    font-weight: 500;
    margin-top: 6px;
    margin-bottom: var(--space-8);
    text-align: center;
  }

  .rak-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 240px));
    justify-content: center;
    gap: var(--space-5);
    width: 100%;
  }

  .rak-empty {
    position: relative;
    overflow: hidden;
    width: 100%;
    max-width: 480px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: var(--space-8) var(--space-6);
    border-radius: var(--rad-catchup-xlarge);
    background: rgba(255, 255, 255, 0.2);
    -webkit-backdrop-filter: blur(28px) saturate(1.8);
    backdrop-filter: blur(28px) saturate(1.8);
    border: 1px solid rgba(255, 255, 255, 0.55);
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.7),
      0 18px 40px -20px rgba(15, 72, 89, 0.4);
  }
  .rak-empty-text {
    font-size: var(--fs-lg);
    font-weight: 500;
    color: var(--text-secondary);
  }

  /* "Sign in with a different account" is now the shared library SecondaryButton;
     the slot keeps its top spacing (centered by .rak-inner). */
  .rak-switch-slot {
    margin-top: var(--space-8);
  }

  .rak-rights {
    position: relative;
    z-index: 1;
    margin-top: var(--space-6);
    text-align: center;
  }

  .rak-loading {
    flex: 1 1 0%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100dvh;
    background-color: var(--catchup-blue-50);
    background-image: linear-gradient(160deg, #DCF5FA 0%, #E7E9FB 50%, #FCE6EE 100%);
  }

  @media (max-width: 720px) {
    .rak-grid {
      grid-template-columns: 1fr;
      max-width: 360px;
    }
  }
`;
